import { Link } from "react-router-dom";
import { useEffect, useState } from "react";

const slides = [
  {
    img: "/images/hero-1.jpg",
    title: "Votre salle de bain,\nréinventée.",
    sub: "Pose de carrelage et rénovation dans le Valais — le travail bien fait n'a pas besoin de slogan. On est votre carreleur à proximité, près de chez vous.",
  },
  {
    img: "/images/hero-2.jpg",
    title: "L'art du carrelage\ndepuis 20 ans.",
    sub: "Artisan carreleur basé à Grône. On intervient à Sion, Sierre, Martigny et dans toute la région à proximité, toujours avec le même soin.",
  },
  {
    img: "/images/hero-3.jpg",
    title: "Du sol au plafond,\nla perfection.",
    sub: "Séjours, cuisines et espaces de vie dans votre région — on pose propre, on finit net, et on laisse derrière nous que de la qualité.",
  },
  {
    img: "/images/hero-4.jpg",
    title: "Le carrelage extérieur\nqui résiste dans le temps.",
    sub: "Terrasse posée sur taquets et chapes en Valais. Stable au fil des hivers, belle au fil des étés. Service de carrelage à proximité de chez vous.",
  },
];

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="relative w-full h-[100vh] min-h-[600px] overflow-hidden">
      {slides.map((slide, i) => (
        <div
          key={i}
          className={`absolute inset-0 transition-opacity duration-1000 ${i === current ? "opacity-100" : "opacity-0"}`}
        >
          <img
            src={slide.img}
            alt={`Carrelage Valais - ${slide.title.replace(/\n/g, ' ')}`}
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/60"></div>
        </div>
      ))}

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <span className="inline-block mb-4 px-4 py-1.5 bg-amber-700/80 text-white text-xs font-medium tracking-widest uppercase rounded-full">
          Artisan carreleur en Valais
        </span>
        <h2 className="text-4xl md:text-6xl font-bold text-white leading-tight mb-6 max-w-3xl whitespace-pre-line">
          {slides[current].title}
        </h2>
        <p className="text-lg text-white/80 mb-10 max-w-xl">
          {slides[current].sub}
        </p>
        <div className="flex flex-col sm:flex-row gap-4">
          <Link
            to="/services"
            className="px-8 py-3.5 bg-amber-700 text-white font-medium rounded-full hover:bg-amber-800 transition-colors whitespace-nowrap flex items-center gap-2"
          >
            Ce qu'on fait
            <i className="ri-arrow-right-line"></i>
          </Link>
          <Link
            to="/contact"
            className="px-8 py-3.5 bg-white/10 backdrop-blur-sm border border-white/40 text-white font-medium rounded-full hover:bg-white/20 transition-colors whitespace-nowrap"
          >
            Parler du projet
          </Link>
        </div>
      </div>

      {/* Slide dots */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex gap-2">
        {slides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`h-1.5 rounded-full transition-all cursor-pointer ${i === current ? "w-8 bg-amber-500" : "w-2 bg-white/50"}`}
          />
        ))}
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 right-8 z-10 flex flex-col items-center gap-2">
        <span className="text-white/50 text-xs tracking-widest uppercase" style={{writingMode: "vertical-rl"}}>Défiler</span>
        <div className="w-px h-12 bg-white/30"></div>
      </div>
    </section>
  );
}